var _excluded = ["ariaLabel", "size", "color", "href", "trackingData", "linkText", "dataClear", "active", "id", "classes", "disabled", "dataApply", "dataSpinnable", "rel", "target", "iconName", "onClick"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import React from "react";
import { Link } from "@xo-union/tk-component-buttons";
import PropTypes from "prop-types";
var LinkAgent = function LinkAgent(_ref) {
  var ariaLabel = _ref.ariaLabel,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'secondary' : _ref$color,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? 'javascript:void(0)' : _ref$href,
    _ref$trackingData = _ref.trackingData,
    trackingData = _ref$trackingData === void 0 ? {} : _ref$trackingData,
    _ref$linkText = _ref.linkText,
    linkText = _ref$linkText === void 0 ? '' : _ref$linkText,
    _ref$dataClear = _ref.dataClear,
    dataClear = _ref$dataClear === void 0 ? false : _ref$dataClear,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? null : _ref$id,
    _ref$classes = _ref.classes,
    classes = _ref$classes === void 0 ? '' : _ref$classes,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? true : _ref$disabled,
    _ref$dataApply = _ref.dataApply,
    dataApply = _ref$dataApply === void 0 ? false : _ref$dataApply,
    _ref$dataSpinnable = _ref.dataSpinnable,
    dataSpinnable = _ref$dataSpinnable === void 0 ? false : _ref$dataSpinnable,
    _ref$rel = _ref.rel,
    rel = _ref$rel === void 0 ? '' : _ref$rel,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? null : _ref$target,
    iconName = _ref.iconName,
    onClick = _ref.onClick,
    passThroughProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Link, _extends({
    id: id,
    size: size,
    "aria-label": ariaLabel,
    color: active ? 'primary' : color,
    href: href,
    "data-params": _JSON$stringify(trackingData),
    "data-clear": dataClear ? 'true' : null,
    className: classes,
    disabled: disabled,
    "data-apply": dataApply ? 'true' : null,
    "data-spinnable": dataSpinnable ? 'true' : null,
    "data-track-results-viewed-event": trackingData['track-results-viewed-event'],
    "data-track-results-viewed-results-type": trackingData['track-results-viewed-results-type'],
    "data-track-results-viewed-page-count": trackingData['track-results-viewed-page-count'],
    "data-track-results-viewed-selected": trackingData['track-results-viewed-selected'],
    rel: rel,
    target: target,
    onClick: onClick,
    iconName: iconName
  }, passThroughProps), linkText);
};
process.env.NODE_ENV !== "production" ? LinkAgent.propTypes = {
  ariaLabel: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  href: PropTypes.string,
  trackingData: PropTypes.object,
  linkText: PropTypes.string,
  dataClear: PropTypes.bool,
  active: PropTypes.bool,
  id: PropTypes.string,
  classes: PropTypes.string,
  disabled: PropTypes.bool,
  dataApply: PropTypes.bool,
  dataSpinnable: PropTypes.bool,
  rel: PropTypes.string,
  target: PropTypes.string,
  iconName: PropTypes.string,
  onClick: PropTypes.func
} : void 0;
export default LinkAgent;